<!-- 仓库主数据 -->
<template>
  <div class="store">
    <div class="main-content">
      <sirui-search
        ref="siruiSearch"
        :query="query"
        :columns="topColumn"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="search"
        @changeMethod="changeMethod"
      ></sirui-search>
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :pageSizes="pageSizes"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <span v-if="item.field === 'attrStatus'">
              {{ row[item.field] == 1 ? '启用' : '禁用' }}
            </span>
            <span v-else-if="item.field === 'isModelCalculate'">
              {{ row[item.field] == 0 ? '否' : '是' }}
            </span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>

    <!-- 新增弹窗 -->
    <AddDialog ref="addDialogRef" @update="update"></AddDialog>
    <!-- 导入 -->
    <sirui-upload
      :action="action"
      @getData="getTableData"
      :isShowDownTemplateBtn="true"
      ref="SiruiUpload"
      :data="{ ...token, attrType: '04' }"
    ></sirui-upload>
  </div>
</template>

<script>
  import { defaultTableColumn } from './index.js';
  import AddDialog from '../components/AddDialog/index.vue';
  import btnMixins from '../../mixins/btnMixins';
  import siruiUpload from '@/components/SiruiUpload';
  export default {
    name: 'Norms',
    mixins: [btnMixins],
    components: { AddDialog, siruiUpload },

    mounted() {
      // this.getTableData();
      this.getButtonList();
      this.getTableData();
    },
    data() {
      return {
        loading: false,
        handleRejectValue: '',
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        selectedList: [],
        tableData: [], // 表格数据
        importUrl: '',
        importData: {},
        columnList: [],
        // showGenerateExpensesDialog: false,
        showAddExpensesDialog: false,
        showContractDialog: false,
        showAdjustmentFeeDialog: false,
        showBatchCreateSettlementDialog: false,
        generateExpensesDialogform: {},
        addExpensesDialogForm: {},
        preSettlementTableData: [],
        query: {
          pageNum: 1,
          pageSize: 10,
          name: '',
          departmentCode: null,
          companyCode: null,
        },
        companyCode: null,
        tableTotal: 15,
        pageSizes: [10, 20, 50, 100, 200, 300, 400, 500],
      };
    },
    methods: {
      // 获取表格数据
      async getTableData() {
        this.getData('04');
      },
      // 增加
      addHandler() {
        this.add('04');
      },
      // 编辑
      editHandler() {
        this.edit('04');
      },
      // 禁用
      disabledHandler() {
        this.changeStatus('2');
      },
      // 启用
      enableHandler() {
        this.changeStatus('1');
      },
      // 删除
      // deleteHandler() {},
      // 导入
      // 导入
      importHandler() {
        this.$refs.SiruiUpload.openDialog(true, '103');
      },
      update() {
        this.resetCheckbox();
        this.getTableData();
      },
      //获取当前列
      getColumnInfo() {
        this.getColumn(defaultTableColumn);
      },
    },
    watch: {},
  };
</script>

<style lang="scss" scoped></style>
